(() => {
  const SUPPORTED_COLLECTIONS = new Set(['all', 'mainline', 'philosophy']);
  const SHIPPING_URL = '/pages/shipping-policy';
  const STORAGE_KEY = `adwoa-pdp-source:${window.location.pathname}`;
  const RELATED_STYLE_IDS = [
    'AdwoaPdpRelatedCatalogCollectionExactRules',
    'AdwoaPdpRelatedCatalogTypographyRules',
    'AdwoaPdpRelatedCatalogCollectionRules'
  ];
  const PDP_HEADER_RETRIES = 120;

  const isProductPage = () => (
    window.location.pathname.includes('/products/') ||
    document.documentElement.classList.contains('adwoa-product-page-active') ||
    Boolean(document.querySelector('.adwoa-product-layout'))
  );

  const removeRelatedCatalogOverrides = () => {
    RELATED_STYLE_IDS.forEach((id) => document.getElementById(id)?.remove());
    document.querySelectorAll('.adwoa-pdp-related-catalog').forEach((node) => node.remove());
  };

  const blockLegacyScrollRedirect = () => {
    if (window.__adwoaPdpBlockLegacyScrollRedirectV4) return;
    window.__adwoaPdpBlockLegacyScrollRedirectV4 = true;

    const stopLegacy = (event) => {
      if (!isProductPage()) return;
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      else if (typeof event.stopPropagation === 'function') event.stopPropagation();
    };

    const stopLegacyKey = (event) => {
      if (!['ArrowDown', 'PageDown', ' ', 'End'].includes(event.key)) return;
      stopLegacy(event);
    };

    window.addEventListener('wheel', stopLegacy, { capture: true, passive: true });
    window.addEventListener('touchmove', stopLegacy, { capture: true, passive: true });
    window.addEventListener('scroll', stopLegacy, { capture: true, passive: true });
    window.addEventListener('keydown', stopLegacyKey, { capture: true });
    document.addEventListener('wheel', stopLegacy, { capture: true, passive: true });
    document.addEventListener('touchmove', stopLegacy, { capture: true, passive: true });
    document.addEventListener('scroll', stopLegacy, { capture: true, passive: true });
    document.addEventListener('keydown', stopLegacyKey, { capture: true });
  };

  const collectionFromUrl = (value) => {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      const match = url.pathname.match(/\/collections\/([^/?#]+)/);
      if (!match) return null;
      const handle = decodeURIComponent(match[1]).toLowerCase();
      return SUPPORTED_COLLECTIONS.has(handle) ? handle : null;
    } catch (error) {
      return null;
    }
  };

  const currentReferrerSource = () => collectionFromUrl(document.referrer);

  const storedSource = () => {
    try {
      const value = sessionStorage.getItem(STORAGE_KEY);
      return SUPPORTED_COLLECTIONS.has(value) ? value : null;
    } catch (error) {
      return null;
    }
  };

  const sourceFromExistingBack = () => {
    const link = document.querySelector('.adwoa-pdp-top-back, .adwoa-pdp-return-strip a, a[href*="/collections/"]');
    return collectionFromUrl(link?.getAttribute('href'));
  };

  const resolveSource = () => {
    const source = currentReferrerSource() || storedSource() || sourceFromExistingBack() || 'all';
    try { sessionStorage.setItem(STORAGE_KEY, source); } catch (error) {}
    return source;
  };

  const bindReturnLink = (link, source) => {
    if (!link) return;
    const handle = SUPPORTED_COLLECTIONS.has(source) ? source : 'all';
    link.href = `/collections/${handle}`;
    link.textContent = handle === 'all' ? '← BACK' : `← BACK TO ${handle.toUpperCase()}`;
  };

  const normaliseTopBack = (source) => {
    document.querySelectorAll('.adwoa-pdp-top-back, .adwoa-product-back, .product__back a, .adwoa-pdp-back').forEach((link) => bindReturnLink(link, source));
  };

  const revealNode = (node) => {
    if (!node) return;
    node.hidden = false;
    node.removeAttribute?.('hidden');
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    node.style.removeProperty('height');
    node.style.removeProperty('max-height');
    node.style.removeProperty('opacity');
  };

  const revealDetails = (detailsRoot) => {
    if (!detailsRoot) return;
    revealNode(detailsRoot);
    detailsRoot.querySelectorAll('[hidden]').forEach(revealNode);
  };

  const replaceShipping = (detailsRoot) => {
    if (!detailsRoot) return;
    detailsRoot.querySelectorAll('a').forEach((link) => {
      if ((link.textContent || '').trim().toUpperCase().includes('SHIPPING')) link.href = SHIPPING_URL;
    });
  };

  const openDetailsNode = (details) => {
    if (!details) return;
    details.open = true;
    details.setAttribute('open', '');
    revealNode(details);
    details.querySelectorAll('[hidden]').forEach(revealNode);
    details.querySelectorAll('.adwoa-pdp-disclosure__content, .adwoa-pdp-description, .product__description, .accordion__content, .rte').forEach((node) => {
      revealNode(node);
      node.style.display = 'block';
    });
  };

  const forceVisibleProductDetails = () => {
    if (!isProductPage()) return;

    document.querySelectorAll('.adwoa-pdp-details, .adwoa-product-details, [data-adwoa-product-details], .product__description').forEach(revealDetails);

    const pdpDisclosures = Array.from(document.querySelectorAll('.adwoa-pdp-details .adwoa-pdp-disclosure, .adwoa-pdp-details details, .adwoa-product-details details'));
    const productDetailDisclosure = pdpDisclosures.find((details) => {
      const label = (details.querySelector('summary, .adwoa-pdp-disclosure__summary')?.textContent || '').trim().toUpperCase();
      return label.includes('DETAIL') || label.includes('DESCRIPTION') || details.querySelector('.adwoa-pdp-description, .product__description');
    }) || pdpDisclosures[0];

    openDetailsNode(productDetailDisclosure);

    document.querySelectorAll('.adwoa-pdp-description, .product__description').forEach((node) => {
      revealNode(node);
      node.style.display = 'block';
    });
  };

  const hideReturnStripStyle = () => {
    if (document.getElementById('AdwoaPdpNoReturnStrip')) return;
    const style = document.createElement('style');
    style.id = 'AdwoaPdpNoReturnStrip';
    style.textContent = 'html.adwoa-product-page-active .adwoa-pdp-return-strip{display:none!important;}';
    document.head.appendChild(style);
  };

  const removeReturnStrip = () => {
    document.querySelectorAll('.adwoa-pdp-return-strip').forEach((strip) => strip.remove());
  };

  const ensureShopAllStyle = () => {
    if (document.getElementById('AdwoaPdpSeamlessShopAllStyle')) return;
    const style = document.createElement('style');
    style.id = 'AdwoaPdpSeamlessShopAllStyle';
    style.textContent = `
      html.adwoa-product-page-active { scroll-behavior: auto !important; }

      .adwoa-pdp-shop-all {
        width: 100%;
        min-height: 100vh;
        background: #fff;
        position: relative;
        z-index: 1;
        clear: both;
      }
      .adwoa-pdp-shop-all__inner {
        width: 100%;
        min-height: 70vh;
      }
      .adwoa-pdp-shop-all__loading,
      .adwoa-pdp-shop-all__fallback {
        min-height: 70vh;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-family: var(--adwoa-pdp-headline-font, "HelveticaNeue-CondensedBold", "Arial Narrow", Helvetica, Arial, sans-serif);
        font-weight: 800;
        letter-spacing: .045em;
        text-transform: uppercase;
        color: #000;
        text-decoration: none;
      }
      .adwoa-pdp-shop-all .shopify-section,
      .adwoa-pdp-shop-all .section,
      .adwoa-pdp-shop-all .collection,
      .adwoa-pdp-shop-all .product-grid-container {
        max-width: none !important;
      }

      html.adwoa-product-page-active .adwoa-pdp-shop-all #main-collection-filters,
      html.adwoa-product-page-active .adwoa-pdp-shop-all facet-filters-form,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets-wrapper,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets-container,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets__form,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets__wrapper,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets-vertical-sort,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facet-filters,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facet-filters__field,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .product-count,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .product-count-vertical,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .mobile-facets__wrapper,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .active-facets,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .collection-hero,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .collection-toolbar,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .collection__toolbar,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .collection-controls,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .adwoa-shop-interface,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .adwoa-collection-controls,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .adwoa-grid-controls,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .title-wrapper-with-link {
        display: none !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets-vertical,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .facets-vertical.page-width,
      html.adwoa-product-page-active .adwoa-pdp-shop-all .product-grid-container,
      html.adwoa-product-page-active .adwoa-pdp-shop-all #ProductGridContainer {
        width: 100vw !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      html.adwoa-product-page-active .adwoa-pdp-disclosure[open] .adwoa-pdp-disclosure__content,
      html.adwoa-product-page-active .adwoa-pdp-description,
      html.adwoa-product-page-active .product__description {
        display: block !important;
        visibility: visible !important;
      }
    `;
    document.head.appendChild(style);
  };

  const embeddedControlSelectors = [
    '#main-collection-filters',
    'facet-filters-form',
    '.facets-wrapper',
    '.facets-container',
    '.facets',
    '.facets__form',
    '.facets__wrapper',
    '.facets-vertical-sort',
    '.facet-filters',
    '.facet-filters__field',
    '.product-count',
    '.product-count-vertical',
    '.mobile-facets__wrapper',
    '.active-facets',
    '.collection-hero',
    '.collection-toolbar',
    '.collection__toolbar',
    '.collection-controls',
    '.adwoa-shop-interface',
    '.adwoa-collection-controls',
    '.adwoa-grid-controls',
    '.title-wrapper-with-link'
  ].join(',');

  const cleanEmbeddedShopAll = (section = document.querySelector('[data-adwoa-pdp-shop-all]')) => {
    if (!section) return;
    section.querySelectorAll(embeddedControlSelectors).forEach((node) => node.remove());

    section.querySelectorAll('header, .header, .section-header, .shopify-section-header').forEach((node) => {
      if (node.querySelector('.product-grid') || node.querySelector('#product-grid')) return;
      node.remove();
    });

    section.querySelectorAll('*').forEach((node) => {
      if (node.children.length > 3 || node.querySelector('.card-wrapper, .product-card-wrapper, #product-grid, .product-grid')) return;
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (!text) return;
      if (/^(FILTER:|SORT BY:|AVAILABILITY|PRICE|VIEW\s+2\s+3\s+4\s+GRID|VIEW:|FILTER)$/.test(text)) node.remove();
    });

    const vertical = section.querySelector('.facets-vertical');
    if (vertical) {
      vertical.style.display = 'block';
      vertical.style.width = '100vw';
      vertical.style.maxWidth = 'none';
      vertical.style.margin = '0';
      vertical.style.padding = '0';
    }

    const grid = section.querySelector('#ProductGridContainer, .product-grid-container');
    if (grid) {
      grid.style.width = '100vw';
      grid.style.maxWidth = 'none';
      grid.style.margin = '0';
      grid.style.padding = '0';
    }
  };

  const shopAllSectionUrl = () => {
    const url = new URL('/collections/all', window.location.origin);
    url.searchParams.set('sections', 'main-collection-product-grid');
    const current = new URLSearchParams(window.location.search);
    ['preview_theme_id', '_ab', '_fd', '_sc'].forEach((key) => {
      if (current.has(key)) url.searchParams.set(key, current.get(key));
    });
    return url.toString();
  };

  const promoteSectionAssets = (fragment) => {
    fragment.querySelectorAll('link[rel="stylesheet"], link[rel="preload"], style').forEach((node) => {
      const signature = node.outerHTML;
      const exists = Array.from(document.head.children).some((child) => child.outerHTML === signature);
      if (!exists) document.head.appendChild(node.cloneNode(true));
      node.remove();
    });
    fragment.querySelectorAll('script').forEach((script) => script.remove());
  };

  const ensurePdpHeaderControls = () => {
    if (!isProductPage()) return false;

    const shopInterface = document.querySelector('[data-adwoa-shop-interface]');
    const left = shopInterface?.querySelector('.adwoa-shop-interface__left');
    if (!left) return false;

    const shopMenu = left.querySelector('.adwoa-shop-menu') || left.firstElementChild;
    let filter = left.querySelector('[data-adwoa-filter]');
    if (!filter) {
      filter = document.createElement('button');
      filter.type = 'button';
      filter.className = 'adwoa-shop-filter';
      filter.dataset.adwoaFilter = '';
      filter.textContent = 'FILTER';
      if (shopMenu?.parentNode) shopMenu.insertAdjacentElement('afterend', filter);
      else left.prepend(filter);
    }

    let view = left.querySelector('.adwoa-shop-view');
    if (!view) {
      view = document.createElement('div');
      view.className = 'adwoa-shop-view';
      view.setAttribute('role', 'group');
      view.setAttribute('aria-label', 'Product display');
      view.innerHTML = `
        <span class="adwoa-shop-view__label">VIEW:</span>
        <button type="button" data-adwoa-view="2" aria-label="Show 2 products per row">2</button>
        <button type="button" data-adwoa-view="3" aria-label="Show 3 products per row">3</button>
        <button type="button" data-adwoa-view="4" aria-label="Show 4 products per row">4</button>
        <button type="button" data-adwoa-view="grid" aria-label="Show 6 products per row">GRID</button>
      `;
      filter.insertAdjacentElement('afterend', view);
    }

    if (shopInterface.dataset.adwoaPdpHeaderControls === 'true') return true;
    shopInterface.dataset.adwoaPdpHeaderControls = 'true';

    const storageKey = 'adwoa-product-grid-view';
    const viewClasses = ['adwoa-view-2', 'adwoa-view-3', 'adwoa-view-4', 'adwoa-view-grid'];
    let selectedView = '3';
    try {
      const savedView = window.localStorage.getItem(storageKey);
      if (['2', '3', '4', 'grid'].includes(savedView)) selectedView = savedView;
    } catch (error) {}

    const buttons = Array.from(view.querySelectorAll('[data-adwoa-view]'));
    const applyView = () => {
      const grid = document.querySelector('[data-adwoa-pdp-shop-all] #ProductGridContainer #product-grid, #ProductGridContainer #product-grid');
      if (!grid) return false;
      grid.classList.remove(...viewClasses);
      grid.classList.add(`adwoa-view-${selectedView}`);
      buttons.forEach((button) => {
        const active = button.dataset.adwoaView === selectedView;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      return true;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedView = button.dataset.adwoaView;
        try { window.localStorage.setItem(storageKey, selectedView); } catch (error) {}
        applyView();
      });
    });

    filter.addEventListener('click', (event) => {
      event.preventDefault();
      const nativeFilter = document.querySelector('#main-collection-filters .mobile-facets__open');
      nativeFilter?.click();
    });

    let attempts = 0;
    const waitForGrid = setInterval(() => {
      attempts += 1;
      const applied = applyView();
      if (applied || attempts > PDP_HEADER_RETRIES) clearInterval(waitForGrid);
    }, 100);

    applyView();
    return true;
  };

  const initSeamlessShopAll = () => {
    if (window.__adwoaPdpSeamlessShopAllV4) {
      cleanEmbeddedShopAll();
      ensurePdpHeaderControls();
      return true;
    }
    if (!isProductPage()) return false;
    const layout = document.querySelector('.adwoa-product-layout');
    if (!layout) return false;
    const anchor = layout.closest('.shopify-section') || layout;
    if (!anchor?.parentNode) return false;

    ensureShopAllStyle();

    let section = document.querySelector('[data-adwoa-pdp-shop-all]');
    if (!section) {
      section = document.createElement('section');
      section.className = 'adwoa-pdp-shop-all';
      section.dataset.adwoaPdpShopAll = 'true';
      section.innerHTML = '<div class="adwoa-pdp-shop-all__inner"><div class="adwoa-pdp-shop-all__loading">SHOP ALL</div></div>';
      anchor.parentNode.insertBefore(section, anchor.nextSibling);
    }

    window.__adwoaPdpSeamlessShopAllV4 = true;
    fetch(shopAllSectionUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.json())
      .then((sections) => {
        const html = sections && sections['main-collection-product-grid'];
        if (!html) throw new Error('Missing collection section');
        const template = document.createElement('template');
        template.innerHTML = html;
        promoteSectionAssets(template.content);
        const inner = section.querySelector('.adwoa-pdp-shop-all__inner') || section;
        inner.replaceChildren(...Array.from(template.content.childNodes));
        section.dataset.adwoaLoaded = 'true';
        cleanEmbeddedShopAll(section);
        ensurePdpHeaderControls();
        setTimeout(() => cleanEmbeddedShopAll(section), 80);
        setTimeout(() => cleanEmbeddedShopAll(section), 400);
      })
      .catch(() => {
        section.innerHTML = '<a class="adwoa-pdp-shop-all__fallback" href="/collections/all">SHOP ALL</a>';
      });

    return true;
  };

  const setup = () => {
    if (!isProductPage()) return;
    document.documentElement.classList.add('adwoa-product-page-active');
    removeRelatedCatalogOverrides();
    removeReturnStrip();
    ensureShopAllStyle();
    ensurePdpHeaderControls();

    const source = resolveSource();
    normaliseTopBack(source);

    const detailsRoot = document.querySelector('.adwoa-product-details, .product__description, .product__accordion, [data-adwoa-product-details], .adwoa-pdp-details');
    revealDetails(detailsRoot);
    replaceShipping(detailsRoot);
    forceVisibleProductDetails();

    initSeamlessShopAll();
    cleanEmbeddedShopAll();
    document.documentElement.classList.add('adwoa-pdp-ux-refined');
  };

  const boot = () => {
    blockLegacyScrollRedirect();
    hideReturnStripStyle();
    removeRelatedCatalogOverrides();
    initSeamlessShopAll();
    setup();
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      setup();
      if (attempts > 40 || document.documentElement.classList.contains('adwoa-pdp-ux-refined')) clearInterval(timer);
    }, 150);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('pageshow', () => {
    setup();
    cleanEmbeddedShopAll();
    ensurePdpHeaderControls();
  });
})();
